import { render } from "./UserWidget.vue?vue&type=template&id=2f2c38ee&scoped=true"
import script from "./UserWidget.vue?vue&type=script&lang=js"
export * from "./UserWidget.vue?vue&type=script&lang=js"

import "./UserWidget.vue?vue&type=style&index=0&id=2f2c38ee&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2c38ee"]])

export default __exports__